export const SKELETON_CARD_COUNT = 9;
